export class RedactionSettingDto {
  isServiceEnabled: boolean;
  type: RedactionType;
  mode: RedactionMode;
  properties: RedactionPropertyDto[];
  isServiceUnavailable: boolean;
}

export class RedactionPropertyDto {
  phraseType: string;
  languageCodes: string[];
  phraseInformationList: PhraseInformationDto[];
  isSelected: boolean;
  revealStartChars?: number;
  revealEndChars?: number;
}

export class PhraseInformationDto {
  displayName: string;
  languageCode: string;
}

export class RedactionSettingCreateOrUpdateDto {
  isServiceEnabled: boolean;
  type?: RedactionType;
  mode?: RedactionMode;
  redactionPhraseTypeSettings?: RedactionPhraseTypeSettingDto[];
}

export class RedactionPhraseTypeSettingDto {
  phraseType: string;
  revealStartChars?: number;
  revealEndChars?: number;
}

export enum RedactionType {
  dynamic,
  static,
}

export enum RedactionMode {
  PIIType,
  Character,
}

export enum RevealMode {
  Off = 'off',
  Start = 'start',
  End = 'end',
}
